export const idlFactory = ({ IDL }) => {
  const Result = IDL.Variant({ Ok: IDL.Bool, Err: IDL.Text })
  const AnalyticsDetails = IDL.Record({
    analytics_id: IDL.Opt(IDL.Text),
    price_provider: IDL.Opt(IDL.Text),
    analytics_provider: IDL.Opt(IDL.Text),
    price_id: IDL.Opt(IDL.Text),
  })
  const TokenDetail = IDL.Record({ value: IDL.Text, kind: IDL.Text })
  const Token = IDL.Record({
    id: IDL.Text,
    fee: IDL.Opt(IDL.Nat),
    decimals: IDL.Nat8,
    chain: IDL.Text,
    name: IDL.Text,
    tags: IDL.Vec(IDL.Text),
    sort_order: IDL.Nat64,
    description: IDL.Text,
    analytics_details: AnalyticsDetails,
    links: IDL.Vec(TokenDetail),
    logo_url: IDL.Text,
    group_id: IDL.Opt(IDL.Text),
    address: IDL.Opt(IDL.Text),
    additional_data: IDL.Vec(TokenDetail),
    standard: IDL.Text,
    symbol: IDL.Text,
  })
  const TokenGroup = IDL.Record({
    id: IDL.Text,
    name: IDL.Text,
    analytics_details: AnalyticsDetails,
    logo_url: IDL.Text,
    symbol: IDL.Text,
  })
  return IDL.Service({
    bulk_insert: IDL.Func([IDL.Text], [Result], []),
    bulk_update: IDL.Func([IDL.Text], [Result], []),
    delete_token: IDL.Func([IDL.Text], [Result], []),
    delete_token_group: IDL.Func([IDL.Text], [Result], []),
    get_all_tokens: IDL.Func([], [IDL.Vec(Token)], ['query']),
    get_token_groups: IDL.Func([], [IDL.Vec(TokenGroup)], ['query']),
    insert_admin: IDL.Func([IDL.Principal], [Result], []),
    insert_token: IDL.Func([Token], [Result], []),
    insert_token_group: IDL.Func([TokenGroup], [Result], []),
    update_token: IDL.Func([Token], [Result], []),
    update_token_group: IDL.Func([TokenGroup], [Result], []),
  })
}
export const init = ({ IDL }) => {
  return []
}
